export default __webpack_public_path__ + "static/media/triangles-no-6.02d5f508.mid";